@media screen and (min-width: 980px) {
  .pes-software-modal-cell {
    font-size: 14px;
    line-height: 1.4285714286;
    padding: 15px;
  }
}

.pes-software-modal-cell--versions {
  font-size: 14px;
  line-height: 1.4285714286;
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .pes-software-modal-cell--versions {
    padding: 20px 65px 15px 30px;
  }

  :host([dir="rtl"]) .pes-software-modal-cell--versions {
    padding: 20px 30px 15px 65px;
  }
}

.pes-software-modal-cell--format {
  text-transform: uppercase;
}

.pes-software-modal-cell--size {
  text-transform: capitalize;
}